import { graphql } from "../gql";

export const searchInFileQueryDoc = graphql(`
  query searchInFile($fileId: ID!, $query: String!) {
    searchInFile(fileId: $fileId, query: $query) {
      ...SearchResultFragment
    }
  }
`);
